<template>
    <div  class="ranking">
        <div  class="title">
            {{title}}
        </div>
        <div  class="content">
            <div class="content_main">
                <div  v-for="(item,index)  in  list"  :key="index">
                    <div  class="first_info">
                        <div  class="name_content">
                            <span  :class="(indexPM-1)*11+index<3?'right_num':'unright_num'">{{(indexPM-1)*10+index+1}}</span>
                            <span  class="info_shop" v-if="item.shop_name">{{item.shop_name.slice(0,15)}}{{item.shop_name.length>15?'...':''}}</span>
                            <img v-if='item.platform_code'  :src='require("@/assets/img/platform/pla_"+item.platform_code+".png")'  class="edit_icon">
                        </div>
                        <slot  name="progress"  :text="item.score?Number(item.score):0"></slot>
                    </div>
                    <div    v-show="rankType==1">{{Number(item.camcount)}}</div>
                    <div    v-show="rankType==2">{{item.score?Number(item.score):0}}</div>
                    <div    v-show="rankType==3||rankType==4">{{Number(item.cheap)}}</div>
                </div>
                <div  class="nodata"  v-if="list.length==0"  style="display:  block"><img  src="@/assets/img/other/nodata.svg">暂无数据</div>

            </div>
            <el-pagination
                    :page-size="10"
                    :pager-count="5"
                    layout="prev, pager, next"
                    :total="pageTotal"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    v-show="pageTotal>0"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export  default  {
        name:  "ranking",
        props:{
            title:{type:String},
            camcount:{},
            list:{type:Array},
            rankType:{type:Number},//1活动商品数排名  2信用积分排名  3灰名单  4黑名单
            pageTotal:{type:Number}
        },
        data:function(){
            return{
                indexPM:1
            }
        },
        methods:{
            handleCurrentChange(val) {
                let data={
                    val,
                    rankType:this.rankType
                }
                this.indexPM=val
                //当前页
                this.$emit("handleCurrentChange",data);
            },
            handleSizeChange(val) {
                console.log(val)
                //每页
            },
        }
    }
</script>

<style  lang="scss">
    .ranking{
        margin-top:  20px;
        .name_content{
            width:  250px;
            display:  flex;
            align-items:  center;
        }
        .el-pager li{
            width: 15px!important;
            min-width: 15px!important;
        }
        .title{
            display:  flex;
            align-items:  center;
            font-size:  16px;
            &:before{
                content:  '';
                display:inline-block;
                width:  5px;
                height:  16px;
                background:  #19233c;
                margin-right:  10px;
            }
        }
        .first_info{
            display:  flex;
            justify-content:  flex-start;
            align-items:  center;
        }
        .content{
            padding:15px 20px;
            height:535px;
            overflow-y:  auto;
            background:  #fff;
            border-radius:  16px;
            margin-top:  20px;
            .content_main{
                height: 500px;
            }
            .content_main>div{
                display:  flex;
                justify-content:  space-between;
                margin-bottom:  31px;
            }
            .el-pagination{
                text-align: right;
            }
            .edit_icon{
                vertical-align:  middle;
            }
            .info_shop{
                margin:0  5px  0  15px;
                font-size:  14px;
                color:  #666;
            }
            .right_num{
                width:  20px;
                height:  20px;
                border-radius:  50%;
                background:  #bda571;
                display: inline-block;
                color: #fff;
                text-align: center;
                line-height: 20px;
                font-size: 14px;
            }
            .unright_num{
                font-size: 14px;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #f0f3fc;
                display: inline-block;
                color: #666;
                text-align: center;
                line-height: 20px;
            }
        }

    }
</style>
